import { connect } from 'react-redux';
import Proofs from 'project/components/wrapup/proofs';
import { getProject } from 'project/ducks/project';
import { getSubCategory } from 'common/ducks/categories';
import { fetchMessagesIfNeeded } from 'common/ducks/message';
import { getPrepopulatedWrapupMsgOpts } from 'admin/utils';

const mapStateToProps = (state, { wrapup }) => {
  const project = state.admin.projects.currentProject || getProject(state);
  const subCategory = getSubCategory(state.categories, project.sub_category);
  const user = state.user.profile_data;

  return {
    itemsToUpload: subCategory.creative_submit_proofs_checklist,
    approveChecklist: subCategory.client_approve_proofs_checklist,
    prepopulatedMsgOpts: getPrepopulatedWrapupMsgOpts({ user, project, wrapup, step: "proofs" })
  };
}

export default connect(mapStateToProps, {
  fetchMessagesIfNeeded
})(Proofs);



// WEBPACK FOOTER //
// ./project/containers/wrapup/proofs.js